export default {
  tablet: 768,
  desktop: 992,
  giant: 1200,
};
